<div class="carousel">
  <swiper-container [config]="config" luiSwiper init="false">
    <swiper-slide *ngFor="let slide of slides">
      <ng-template [ngTemplateOutlet]="slide.template"></ng-template>
    </swiper-slide>
  </swiper-container>
  <ng-content></ng-content>
</div>
